/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { getSSRAttach, getAttach } from '../utils/dom.mjs';
import { computed, ref, onMounted, watch } from 'vue';
import { i as isFunction_1 } from '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../utils/easing.mjs';
import '../_chunks/dep-16e2f1a5.mjs';

var useTeleport = function useTeleport(attach, triggerNode) {
  var to = isFunction_1(attach) ? computed(attach) : ref(attach);
  var innerTriggerNode = isFunction_1(triggerNode) ? computed(triggerNode) : ref(triggerNode);
  var element = ref();
  var getElement = function getElement() {
    element.value = getSSRAttach() || getAttach(to.value, innerTriggerNode.value);
  };
  onMounted(function () {
    return getElement();
  });
  watch([to, innerTriggerNode], function () {
    return getElement();
  });
  return element;
};

export { useTeleport as default };
//# sourceMappingURL=useTeleport.mjs.map
